import React, {useRef} from 'react';
import styles from './styles';
import Dashboard from './Dashboard';
import {UserContext} from '../../Context/UserContext';

const Home = props => {

  const {user, userAction} = React.useContext(UserContext);


  const instance = props.match.params.instance ? props.match.params.instance : user.instance;
  const pathParams = window.location.pathname.split('?')[0];

  // track initial redirect action
  const initialRedirect = useRef(props.location && props.location.pathname.includes(instance));

  // redirect to home on initial login
  if(user.loggedIn && !initialRedirect.current
    && (pathParams === '/' + instance  + '/' || pathParams === '/' + instance)) {
    initialRedirect.current = true;
    props.history.push({
      pathname: r + '/home',
      state: {
        auth: user,
        instance: user.instance,
      }
    })
  }

  return (
      <div id="dashboard-main" style={styles.dashContainer}>
      {
          user.loggedIn
          ? <Dashboard {...props} />
          : null
      }
      </div>
  );
}

export default Home;
